import React from 'react';
import { LegendItem } from './LegendItem';
import { LegendContainer } from './style';
import statusColorMap from 'constants/statusColorMap';

const Legend = ({desktop, mobile}) => {
  return (
    <LegendContainer desktop={desktop} mobile={mobile}>
      <div className='legendTitle'>Room Statuses</div>
      <LegendItem
        backgroundColor={statusColorMap['CHECKED_IN']}
        legendLabel="Checked-in"
      />
      <LegendItem
        backgroundColor={statusColorMap['PENDING']}
        legendLabel="Pending"
      />
      <LegendItem
        backgroundColor={statusColorMap['CHECKED_OUT']}
        legendLabel="Checked-out"
      />
      <LegendItem
        backgroundColor={statusColorMap['EXPIRED']}
        legendLabel="Expired"
      />
    </LegendContainer>
  );
};

export default Legend;
